export const contentTableConfig = {
  title: '定时发送弹幕管理',
  propList: [
    {
      prop: 'content',
      label: '发送内容',
      minWidth: '200',
      align: 'left'
    },
    {
      prop: 'sendTime',
      label: '发送时间',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'updateTime',
      label: '更新时间',
      minWidth: '80',
      sortable: true
    },
    {
      prop: 'sendStatus',
      label: '发送状态',
      minWidth: '80',
      slotName: 'sendStatus'
    },
    {
      label: '操作',
      minWidth: '100',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  action: process.env.VUE_APP_BASE_URL + '/main/autoChat/dataImport'
}
